import React from 'react'
import DatePicker from 'material-ui/DatePicker'
import classNames from 'classnames'
import moment from 'moment'
import _ from "lodash";
import userService from "../../services/user-service";

export default class RenderWhen extends React.Component {
  render() {
    const {requiredPermissions, currentUser, authorized, unauthorized} = this.props
    let userPermissions = userService.getUserPermissions(currentUser)
    for (let i = 0; i < requiredPermissions.length; i++) {
      if (userPermissions.indexOf(requiredPermissions[i]) < 0) {
        return unauthorized || null
      }
    }
    return authorized
  }
}



// WEBPACK FOOTER //
// ./src/components/RenderWhen/RenderWhen.js